import React from 'react';
import { Flex, Popover } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { searchFilter as SearchFilterIcon } from '@/assets/icons/icons';
import { CustomButton, SearchInput } from '@/components';

export interface ShipmentSearchControlProps {
  isSearchVisible: boolean;
  isCompactSearch: boolean;
  searchPopoverOpen: boolean;
  searchQuery: string;
  appliedSearchQuery?: string;
  savedFilterKey: string;
  setSearchQuery: (val: string) => void;
  handleSearch: () => void;
  handleCloseSearch: () => void;
  handleResetSearch?: () => void;
  handleSearchIconClick: () => void;
  handlePopoverClose?: () => void;
  setSearchPopoverOpen: (open: boolean) => void;
  tableView?: boolean;
}

const ShipmentSearchControl: React.FC<ShipmentSearchControlProps> = ({
  isSearchVisible,
  isCompactSearch,
  searchPopoverOpen,
  searchQuery,
  appliedSearchQuery,
  savedFilterKey,
  setSearchQuery,
  handleSearch,
  handleCloseSearch,
  handleResetSearch,
  handleSearchIconClick,
  handlePopoverClose,
  tableView = false,
}) => {
  const hasActiveSearch = (appliedSearchQuery || '').trim().length > 0;

  return (
    <div
      className={`shipment-search-control${
        isSearchVisible && !isCompactSearch && tableView ? ' is-open' : ''
      }`}
    >
      {isSearchVisible && !isCompactSearch ? (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSearch();
          }}
          style={{ display: 'contents' }}
        >
          <Flex className='search-filter' align='center' gap={4}>
            <SearchInput
              borderWidth='2px'
              placeholder=''
              defaultValue={searchQuery}
              onChange={(val: string) => {
                setSearchQuery(val);
              }}
              onClear={handleResetSearch}
              style={{ flex: 1 }}
              prefixIcon={<SearchFilterIcon width={12} height={12} />}
              onPressEnter={(val) => {
                setSearchQuery(val.trim());
                // form onSubmit fires handleSearch() immediately
              }}
            />
            <CustomButton
              text='Cancel'
              onClick={handleCloseSearch}
              bgColor='transparent'
              color='var(--text-primary)'
              fontSize='12px'
              fontWeight='400'
              lineHeight='16px'
              height='28px'
              boxShadow='none'
              padding='2px'
            />
          </Flex>
        </form>
      ) : (
        <Popover
          open={isCompactSearch && searchPopoverOpen}
          onOpenChange={(open) => {
            if (!open && handlePopoverClose) {
              handlePopoverClose();
            }
          }}
          trigger='click'
          placement='bottomLeft'
          arrow={false}
          content={
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSearch();
              }}
              style={{ display: 'contents' }}
            >
              <Flex className='search-filter' align='center' gap={4}>
                <SearchInput
                  borderWidth='2px'
                  placeholder=''
                  defaultValue={searchQuery}
                  onChange={(val: string) => {
                    setSearchQuery(val);
                  }}
                  onClear={handleResetSearch}
                  style={{ flex: 1 }}
                  prefixIcon={<SearchFilterIcon width={12} height={12} />}
                  onPressEnter={(val) => {
                    setSearchQuery(val.trim());
                    // form onSubmit fires handleSearch() immediately
                  }}
                />
                <CustomButton
                  text='Cancel'
                  onClick={handleCloseSearch}
                  bgColor='transparent'
                  color='var(--text-primary)'
                  fontSize='12px'
                  fontWeight='400'
                  lineHeight='16px'
                  height='28px'
                  boxShadow='none'
                  padding='2px'
                />
              </Flex>
            </form>
          }
        >
          <Flex
            align='center'
            justify='center'
            className={`searchIconBtn ${
              savedFilterKey === 'ai_history' ? 'is-ai-history' : ''
            } ${hasActiveSearch ? 'search-active' : ''}`}
            onClick={handleSearchIconClick}
            style={
              hasActiveSearch ? { backgroundColor: '#000', color: '#fff' } : {}
            }
          >
            <SearchOutlined style={{ fontSize: '12px' }} />
          </Flex>
        </Popover>
      )}
    </div>
  );
};

export default ShipmentSearchControl;
